import AgencyHelper from 'features/Agency/agencyHelper';
import DealerHelper from 'features/ManageDealer/dealerHelper';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTDropdownFilter from 'general/components/OtherKeenComponents/KTDropdownFilter';
import CustomDateRangePicker, { dateFilter } from 'general/components/Others/CustomDateRangePicker';
import AppConstants from 'general/constants/AppConstants';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Global from 'general/utils/Global';

VoucherPartnerListFilterView.propTypes = {
    setFilterDropdown: PropTypes.func,
    filterDropdown: PropTypes.object,
    areaProvinceOptions: PropTypes.array,
    areaDistrictOptions: PropTypes.array,
    selectedAreaDistrict: PropTypes.object,
    setSelectedAreaDistrict: PropTypes.func,
    selectedAreaProvince: PropTypes.object,
    setSelectedAreaProvince: PropTypes.func,
    areaProvinceList: PropTypes.array,
    areaDistrictList: PropTypes.array,
    adminRole: PropTypes.bool,
};

function VoucherPartnerListFilterView({
    setFilterDropdown,
    filterDropdown,
    areaProvinceOptions,
    areaDistrictOptions,
    selectedAreaDistrict,
    setSelectedAreaDistrict,
    selectedAreaProvince,
    setSelectedAreaProvince,
    areaProvinceList,
    areaDistrictList,
    adminRole,
}) {
    // MARK: ---- PROPERTIES ----

    // MARK: ---- METHODS ----

    return (
        <div>
            <div className={`${'col-12 p-0'}`}>
                <KTFormSearch
                    name="search-bar"
                    placeholder='Theo mã đối tác, tên đối tác, số điện thoại, email, mã số thuế/CCCD'
                    value={filterDropdown.q}
                    onSubmit={(text) => {
                        const updateFilterDropdown = { ...filterDropdown, q: text };
                        setFilterDropdown(updateFilterDropdown);
                    }}
                />
            </div>
            <div className='row d-flex flex-row flex-wrap'>
                {/* loai đối tác */}
                <KTDropdownFilter
                    label='Loại đối tác'
                    filterKey="type"
                    options={DealerHelper.filterAgencyTypeOptions()}
                    selectedValue={filterDropdown.type}
                    additionalClassName='col-md-6 py-2 pr-2'
                    handleChange={(value) => {
                        setFilterDropdown({ ...filterDropdown, type: value });
                    }}
                />
                {/* trang thai */}
                <KTDropdownFilter
                    label='Trạng thái'
                    filterKey="status"
                    options={DealerHelper.filterStatusOptions()}
                    selectedValue={filterDropdown.status}
                    additionalClassName='col-md-6 pl-2'
                    handleChange={(value) => {
                        const isSigned = value === 'SIGNED';
                        const newStatus = isSigned ? '' : value;
                        const newHasSignedContract = isSigned ? 1 : '';

                        setFilterDropdown({
                            ...filterDropdown,
                            status: newStatus,
                            hasSignedContract: newHasSignedContract,
                        });
                    }}
                />

                {/* khoang thoi gian */}
                <div className={`col-6 py-2 pr-2`}>
                    <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                        Khoảng thời gian
                    </label>
                    <CustomDateRangePicker
                        toggleElementBorderRadius={5}
                        alignRight={true}
                        initialValue={
                            filterDropdown.selectedValue?.length > 0
                                ? filterDropdown.selectedValue
                                : dateFilter.tatCaThoiGian
                        }
                        onPressSave={(selectedValue, startDate, endDate) => {
                            const updateFilterDropdown = {
                                ...filterDropdown,
                                from: startDate,
                                to: endDate,
                                selectedValue: selectedValue,
                            };
                            setFilterDropdown(updateFilterDropdown);
                        }}
                    />
                </div>

                {/* quoc gia */}
                <KTDropdownFilter
                    label='Quốc gia'
                    filterKey="country"
                    options={AgencyHelper.Data.CountryOptions}
                    selectedValue={filterDropdown.country}
                    additionalClassName={`col-md-6 pl-2`}
                    handleChange={(value) => {
                        setSelectedAreaProvince('');
                        setSelectedAreaDistrict('');
                        setFilterDropdown({ ...filterDropdown, country: value, areaId: '' });
                    }}
                />

                {/* tinh/thanh pho */}
                <KTDropdownFilter
                    label='Tỉnh/Thành phố'
                    filterKey="areaId"
                    options={areaProvinceOptions}
                    selectedOption={selectedAreaProvince}
                    selectedValue={filterDropdown.areaId}
                    additionalClassName={`col-md-6 pr-2`}
                    searchable={true}
                    handleChange={(value) => {
                        const province = _.find(areaProvinceList, (item) => item.areaId === value);
                        setSelectedAreaProvince(province);
                        setSelectedAreaDistrict('');
                        setFilterDropdown({ ...filterDropdown, areaId: value });
                    }}
                    disabled={filterDropdown.country !== 'VN'}
                />

                {/* phuong/xa */}
                <KTDropdownFilter
                    label='Phường/Xã'
                    filterKey="areaId"
                    options={areaDistrictOptions}
                    selectedOption={selectedAreaDistrict}
                    selectedValue={filterDropdown.areaId}
                    additionalClassName={`col-md-6 pl-2'}`}
                    searchable={true}
                    handleChange={(value) => {
                        setSelectedAreaDistrict(_.find(areaDistrictList, (item) => item.areaId === value));
                        setFilterDropdown({ ...filterDropdown, areaId: value });
                    }}
                    disabled={filterDropdown.country !== 'VN'}
                />
            </div>
        </div>
    );
}

export default VoucherPartnerListFilterView;
